import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

/** Browser modal inertness protects every editor, including controls mounted during a cookie switch. */
@Injectable({ providedIn: 'root' })
export class NotificationSwitchingService {
  private readonly document = inject(DOCUMENT);

  public block(): () => void {
    const dialog = this.document.createElement('dialog');
    dialog.className = 'rounded-lg bg-white p-16 text-primary-900 shadow-dialog';
    dialog.setAttribute('aria-label', 'Switching account');
    dialog.tabIndex = -1;
    const status = this.document.createElement('p');
    status.className = 'text-lg';
    status.setAttribute('role', 'status');
    status.textContent = 'Switching account…';
    dialog.append(status);
    // Escape cannot cancel a mutation already sent to the server.
    dialog.addEventListener('cancel', (event) => event.preventDefault());
    dialog.addEventListener('keydown', (event) => event.stopPropagation());
    this.document.body.append(dialog);
    try {
      dialog.showModal();
    } catch (error: unknown) {
      dialog.remove();
      throw error;
    }
    let active = true;
    return (): void => {
      if (!active) return;
      active = false;
      dialog.close();
      dialog.remove();
    };
  }
}
